import React from "react"
import {useQueries} from "react-query"
import moment from "moment"
import useAuth from "auth/useAuth"
import {areaDataQuery} from "hooks/areaDataQuery"
import {getReportDate} from "utils/utils"
import {collectReportWarnings, severityIcon} from "utils/report_warnings"
import "./ShiftDashboard.css"


function getDashboardDates() {
    const dates = []
    for (let i = 0; i < 3; i++) {
        dates.push(moment().subtract(i, 'days').format('YYYY-MM-DD'))
    }
    return dates
}


export default function ShiftDashboard({area}) {

    const {auth, API} = useAuth()
    const dates = getDashboardDates()

    const queries = useQueries(dates.map(date => ({
        ...areaDataQuery(auth, API, area, date),
        staleTime: 5 * 60 * 1000,
        retry: 1,
        enabled: !!area
    })))

    const isLoading = area && queries.some(q => q.isLoading)
    const items = !isLoading ? collectReportWarnings(area, dates, queries.map(q => q.data), getReportDate()) : []

    if (!area || isLoading || items.length === 0) return null

    return <section className="container-fluid shadow white" id="shift-dashboard">
        <div className="dashboard-items">
            {items.map(item =>
                <div key={item.key} className={`dashboard-item ${item.severity}`}>
                    <i className={`fas ${severityIcon(item.severity)}`}/>
                    {item.content}
                </div>
            )}
        </div>
    </section>
}
